import { Record } from 'immutable'

import { OT_TYPES } from '../notes/record'

const DefaultRecord = Record(
  {
    id: '',
    title: '',
    snapshot: null,
    channelId: '',
    otType: OT_TYPES.RICH_TEXT,
    iconShape: null,
    iconColor: null,
    hasChildren: false,
    parentNote: null,
    listPosition: -1,

    publicShareToken: false,
    publiclySharedAt: null,
    publiclySharedBy: null,
    madePubliclyEditableAt: null,
    madePubliclyEditableBy: null,
  },
  'publicNote'
)

class PublicNotesRecord extends DefaultRecord {
  mergeFrowRaw(data) {
    return this.merge(data)
  }

  static createFromRaw(data) {
    const noteRecord = new PublicNotesRecord({ id: data.id })
    return noteRecord.mergeFrowRaw(data)
  }
}

export default PublicNotesRecord

export function createFromRaw(rawNote) {
  return PublicNotesRecord.createFromRaw(rawNote)
}
